import React from 'react';
import Button from '@material-ui/core/Button';
import classnames from 'classnames';
import { ExpandMore } from '@material-ui/icons';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles({
  content: {
    borderRadius: '8px',
    border: `solid 1px ${colors.border.grey1}`,
    backgroundColor: colors.white,
    '&:hover': {
      border: `solid 1px ${colors.blue3}`,
      backgroundColor: colors.blue1,
    },
  },
  selected: {
    borderRadius: '8px',
    border: `solid 1px ${colors.blue3}`,
    backgroundColor: colors.blue1,
    '&:hover': {
      border: `solid 1px ${colors.blue3}`,
      backgroundColor: colors.blue1,
    },
    color: colors.blue3,
    fontWeight: 'bold',
  },
  icon: {
    color: colors.blue3,
    fontSize: fontSize.large,
  },
  customStyle: {
    textTransform: 'none',
    fontSize: fontSize.smallTitle,
    margin: '2px 4px 2px 0px',
    marginRight: '8px',
  },
  label: {
    marginLeft: '8px',
  },
  popper: {
    zIndex: '998',
    maxWidth: '400px',
  },
});

export default function DropdownButton({ label, onChange, options }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(options[0]?.value || 0);

  const handleMenuItemClick = option => {
    setSelectedIndex(option?.value);
    onChange && onChange(option);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const menuOptions = options?.length > 0 && (
    <MenuList id="split-button-menu">
      {options.map(option => (
        <MenuItem key={option.id} selected={option.value === selectedIndex} onClick={() => handleMenuItemClick(option)}>
          {option.label}
        </MenuItem>
      ))}
    </MenuList>
  );

  return (
    <>
      {options?.length > 0 && (
        <Button
          size="small"
          aria-expanded={open ? 'true' : undefined}
          aria-label={label}
          aria-haspopup="menu"
          onClick={handleToggle}
          className={classnames(open ? classes.selected : classes.content, classes.customStyle)}
          ref={anchorRef}
        >
          <span className={classes.label}>
            {options?.filter(item => item.value == selectedIndex)[0]?.label || options[0]?.label}
          </span>
          <ExpandMore className={classes.icon} />
        </Button>
      )}

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        className={classes.popper}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>{menuOptions}</ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
